export default "__VITE_ASSET__BrO$pYKU__"